const DEFAULT_GENDER_OPTIONS = [
  {value: 'M', label: 'Male'},
  {value: 'F', label: 'Female'},
  {value: 'O', label: 'Other'},
];

const WealthyConstants = {
  SUPPORT_EMAIL_ID: 'customer.support@wealthy.in',
  SUPPORT_MOBILE_NUMBER: '+91 7949121313',
  DEFAULT_GENDER_OPTIONS,
};

export default WealthyConstants;
